export default __webpack_public_path__ + "static/media/header-logo.8e9da821.png";